export default "__VITE_PUBLIC_ASSET__96573c04__"